import {
	MdAssignmentTurnedIn,
	MdStars,
	MdDashboardCustomize,
	MdTouchApp,
	MdNotificationsActive,
} from 'react-icons/md';

import React, { useRef } from 'react';
import './AboutSection.css';
import { Link } from 'react-router-dom';
import { motion, useInView } from 'framer-motion';
import { isIOS } from '../../hooks/isIos';

const AssigmentTurnedIn = MdAssignmentTurnedIn as React.FC<React.SVGProps<SVGSVGElement>>;
const Stars = MdStars as React.FC<React.SVGProps<SVGSVGElement>>;
const DashboardCustomize = MdDashboardCustomize as React.FC<React.SVGProps<SVGSVGElement>>;
const TouchApp = MdTouchApp as React.FC<React.SVGProps<SVGSVGElement>>;
const NotificationsActive = MdNotificationsActive as React.FC<React.SVGProps<SVGSVGElement>>;

export function AboutSection() {
	const ref = useRef(null);
	const marginValue = isIOS() ? '0px' : '-350px';
	const isInView = useInView(ref, { once: true, margin: marginValue });

	const features = [
		{
			title: 'Klare Aufgabenverteilung',
			description:
				'Jede Aufgabe kann Familienmitgliedern zugewiesen werden – ohne Verwirrung oder Diskussionen.',
			icon: AssigmentTurnedIn,
		},
		{
			title: 'Flexibles Belohnungssystem',
			description:
				'Punkte oder kleine Belohnungen motivieren Kinder und Erwachsene gleichermaßen.',
			icon: Stars,
		},
		{
			title: 'Transparente Übersicht',
			description:
				'Alle Aufgaben, erledigt oder offen, auf einen Blick für die ganze Familie.',
			icon: DashboardCustomize,
		},
		{
			title: 'Einfache Bedienung',
			description: 'Intuitive App-Oberfläche – speziell für Familienalltag entwickelt.',
			icon: TouchApp,
		},
		{
			title: 'Benachrichtigungen',
			description: 'Push-Reminder für wichtige oder vergessene Aufgaben.',
			icon: NotificationsActive,
		},
	];

	return (
		<section className='about-section' ref={ref}>
			<motion.h1
				initial={{ opacity: 0, y: 20 }}
				animate={isInView ? { opacity: 1, y: 0 } : {}}
				transition={{ duration: 0.6 }}
			>
				Wie <span style={{ color: '#6C5CE7' }}>Erledix</span> dich unterstützt
			</motion.h1>

			<div className='feature-list'>
				{features.map((feature, index) => {
					const IconComponent = feature.icon;
					return (
						<motion.div
							className='feature-card'
							key={index}
							initial={{ opacity: 0, y: 30 }}
							animate={isInView ? { opacity: 1, y: 0 } : {}}
							transition={{
								delay: 0.2 + index * 0.15,
								duration: 0.5,
								ease: 'easeOut',
							}}
						>
							<IconComponent className='feature-icon' />
							<div>
								<h3 className='feature-title'>{feature.title}</h3>
								<p className='feature-description'>{feature.description}</p>
							</div>
						</motion.div>
					);
				})}

				<motion.div
					initial={{ opacity: 0, y: 20 }}
					animate={isInView ? { opacity: 1, y: 0 } : {}}
					transition={{ delay: 0.2 + features.length * 0.15, duration: 0.5 }}
				>
					<Link to='/beta-signup' className='cta-button'>
						Werde jetzt Teil der Erledix Community!
					</Link>
				</motion.div>
			</div>
		</section>
	);
}
